import { supabase } from '../lib/supabase';

export const createPayment = async ({ proxyType, gbAmount, priceUsd, pricePerGb, durationDays }) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      return { success: false, error: 'Not authenticated' };
    }

    const body = { proxyType, gbAmount, priceUsd, pricePerGb };
    if (durationDays) {
      body.durationDays = durationDays;
    }

    const response = await supabase.functions.invoke('create-payment', {
      body,
    });

    if (response.error) {
      return { success: false, error: 'Failed to create payment' };
    }

    const data = response.data;
    if (!data.success) {
      return { success: false, error: data.error || 'Failed to create payment' };
    }

    return {
      success: true,
      paymentUrl: data.paymentUrl,
      orderId: data.orderId,
      uuid: data.uuid,
    };
  } catch (error) {
    return { success: false, error: 'Payment service unavailable' };
  }
};

export const checkOrderStatus = async (orderId) => {
  try {
    const { data, error } = await supabase
      .from('pending_orders')
      .select('*')
      .eq('order_id', orderId)
      .single();

    if (error) {
      return { success: false, error: 'Order not found' };
    }

    return {
      success: true,
      status: data.status,
      paidAt: data.paid_at,
      bandwidthPackageId: data.bandwidth_package_id,
    };
  } catch (error) {
    return { success: false, error: 'Failed to check order status' };
  }
};

export const getPendingOrders = async () => {
  try {
    const { data, error } = await supabase
      .from('pending_orders')
      .select('*')
      .eq('status', 'pending')
      .order('created_at', { ascending: false });

    if (error) {
      return { success: false, error: 'Failed to fetch orders' };
    }

    return { success: true, orders: data || [] };
  } catch (error) {
    return { success: false, error: 'Failed to fetch orders' };
  }
};

export default {
  createPayment,
  checkOrderStatus,
  getPendingOrders,
};
